import { IFile, IFoldersWithMaterial } from '@sdk/contracts';

import { Upload } from '@/components/Upload';
import { useCourseDetail, useMutateCourses, useProfile } from '@/store';
import { IUpload } from '@/types';

type Props = {
  folder: IFoldersWithMaterial;
};

export const Attachments: React.FC<Props> = ({ folder }) => {
  const { updateFolderMaterial } = useMutateCourses();
  const { course } = useCourseDetail();
  const {
    roleCheck: { isManager }
  } = useProfile();

  if (!course || !isManager) return null;

  const handleUpload = (newUpload: IUpload['value']) => {
    if (!newUpload) {
      return;
    }

    if (Array.isArray(newUpload)) {
      uploadMaterial(newUpload);
      return;
    }

    uploadMaterial([newUpload]);
  };

  const uploadMaterial = (newMaterial: IFile[]) =>
    updateFolderMaterial(course._id, folder, newMaterial);

  return (
    <Upload block mode="upload" onChange={handleUpload} accept="application/pdf" fileList={[]} />
  );
};
